<template>
  <!-- Start Tax rate -->
  <div class="m-taxRate" v-if="taxAmount">
    <div class="row m-taxRate--subtotal">
      <span class="m-taxRate--subtotal__title">Subtotal</span>
      <span class="m-taxRate--subtotal__amount">{{ tllRemainingDays ? "0.00" : subTotalAmount }}</span>
    </div>
    <div class="row m-taxRate--taxes">
      <span v-if="countryCode === 'NZ'" class="m-taxRate--taxes__title">Includes sales tax @ 15%</span>
      <span v-else class="m-taxRate--taxes__title">
          Tax <span v-if="taxAmount !== 0">@ {{taxRate}}%</span>
      </span>
      <span class="mobile-spinner" v-show="taxChangeLoading">
          <i class="fad fa-spinner-third fa-spin" aria-hidden="true"></i>
      </span>
      <span  v-if="countryCode !== 'NZ'" class="m-taxRate--taxes__amount">{{ taxAmount }}</span>
    </div>
    <hr>
  </div>
  <!-- end tax rate -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    taxRate: state => state.cart.taxRate,
    taxAmount: state => state.cart.taxAmount,
    subTotalAmount: state => state.cart.subTotalAmount,
    countryCode: state => state.cart.countryCode,
    tllRemainingDays: state => state.cart.items[0] ? state.cart.items[0].tll_remaining_days : 0,
    taxChangeLoading: state => state.globalstate.taxChangeLoading
  }),
  watch: {
    taxChangeLoading () {
      const taxRateSubTotal = document.getElementsByClassName('m-taxRate--subtotal')[0]
      const taxRateTitle = document.getElementsByClassName('m-taxRate--taxes__title')[0]
      const taxRateAmount = document.getElementsByClassName('m-taxRate--taxes__amount')[0]
      if (
        taxRateSubTotal !== undefined &&
        taxRateAmount !== undefined &&
        taxRateTitle !== undefined
      ) {
        if (this.taxChangeLoading === true) {
          taxRateSubTotal.style.opacity = 0.2
          taxRateTitle.style.opacity = 0.2
          taxRateAmount.style.opacity = 0.2
        } else {
          taxRateSubTotal.style.opacity = 1
          taxRateTitle.style.opacity = 1
          taxRateAmount.style.opacity = 1
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TaxRate.vue?cdfa1c5c